import { Modal } from "antd";
import React from "react";
import styled from "styled-components";
import { ReactComponent as Tick } from "../../assets/tick.svg";
import { ReactComponent as Delete } from "../../assets/Deletetick.svg";
const StyledModal = styled(Modal)`
  text-align: center;
`;

const SuccessDeclinePopup = ({ open, setOpen, message, type }) => {
  return (
    <StyledModal
      width={190}
      height={70}
      open={open}
      onCancel={() => setOpen(false)}
      footer={false}
      closable={false}
      style={{ marginTop: "130px" }}
    >
      <div className="success-modal">
        {type === "success" ? <Tick /> : <Delete />}
        <p className="sent-successfully">{message}</p>
      </div>
    </StyledModal>
  );
};

export default SuccessDeclinePopup;
